<div class="d-flex gap-3 flex-column">
    <label *ngIf="label">
        {{label}}
    </label>

    <div class="row">
        <div class="col-8">
            <input [type]="type" [formControl]="textControl" class="custom-input" [placeholder]="placeholder"
                [ngClass]="{'is-invalid': isTextControlValid()}" />
        </div>
        <div class="col-4">
            <ng-select appearance="outline" [placeholder]="placeholder" (ngModelChange)="onValueChange($event)"
                [items]="options" [bindLabel]="currentBindLabel" [bindValue]="'id'" [(ngModel)]="value"
                [appendTo]="appendTo">
                <ng-template ng-label-tmp let-item="item">
                    <span class=""> {{ placeholder }}</span>
                </ng-template>
            </ng-select>
        </div>
    </div>

    <span class="error-label" *ngIf="isValid() && errorMessage">
        {{errorMessage}}
    </span>
</div>